import React, { useEffect, useState } from "react";
import Layout from "../../../components/dashboard/Layout";
import SearchBar from "../../../containers/admin/lessons/searchbar";
import LessonsTable from "../../../containers/admin/lessons/table";
import { getAllLessonsRequest } from "../../../modules/admin-modules/lessons/Actions";
import { useDispatch } from "react-redux";
import AddLesson from "../../../containers/admin/lessons/models/add-lesson";

const Lessons = () => {
  const [isAdd, setAdd] = useState(false);
  const [selectedData, setSelectedData] = useState({});
  const [searchTerm, setSearchTerm] = useState("");
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getAllLessonsRequest());
  }, [dispatch]);

  return (
    <Layout>
      <SearchBar
        setAdd={setAdd}
        setSelectedData={setSelectedData}
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
      />
      <LessonsTable setAdd={setAdd} setSelectedData={setSelectedData} searchTerm={searchTerm} />
      <AddLesson
        key={`lesson-${isAdd}-${selectedData?.id ?? "new"}`}
        isAdd={isAdd}
        data={selectedData}
        setSelectedData={setSelectedData}
      />
    </Layout>
  );
};

export default Lessons;
